import styled from "styled-components";

export const StepContainer = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 130px;
  width: 100%;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 0.75rem;

  .hidden {
    visibility: hidden;
  }

  .current-step {
    border: 2px solid #ff4e05;
  }

  .active-step {
    background: #ff4e05;
    border: 2px solid #ff4e05;
    color: #fff;
  }

  .active-line {
    background: #ff4e05;
  }
`;

export const TrackLine = styled.span`
  width: 100%;
  height: 3px;
  background: #ebebeb;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const StepIcon = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 24px;
  min-height: 24px;

  background: #fafafa;
  /* Grey01 */

  border: 2px solid #ebebeb;
  border-radius: 24px;

  font-weight: 700;
  font-size: 14px;
  color: #ff4e05;
  line-height: 18px;

  text-align: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 130px;

  font-weight: 400;
  font-size: 13px;
  line-height: 16px;

  text-align: center;

  color: #565f7e;
`;
